import { accountConstants, reduxActions, routes, requestStatus, fetchTypes } from '../constants';
import { AuthDelegate } from '../utils';

const accountStatuses = accountConstants.statuses;
const accountRoles = accountConstants.roles;
const loginStates = accountConstants.loginStates;

const defaultAccount = {
    role: accountRoles.CUSTOMER,
    email: '',
    password: '',
    confirmPassword: '',
    status: accountStatuses.UNSUBMITTED
};

export function registerAccount(state = defaultAccount, action) {
    switch(action.type) {
        case reduxActions.UPDATE_APPLICATION_ACCOUNT:
        return Object.assign({}, state, action.account, {
            valid: Object.assign({}, state.valid || {}, action.account.valid)
        });
        case reduxActions.RESET_APPLICATION_ACCOUNT:
        return defaultAccount;
        default:
        return state;
    }
}

const defaultRegistrationPage = routes.REGISTER;

export function registrationPage(state = defaultRegistrationPage, action) {
    switch (action.type) {
        case reduxActions.SET_REGISTRATION_PAGE:
        return action.page;
        case reduxActions.RESET_REGISTRATION_PAGE:
        return defaultRegistrationPage;
        default:
        return state
    }
}

const defaultNetworkStatus = {
    status: requestStatus.INACTIVE,
    message: ''
};

export function loginStatus(state = defaultNetworkStatus, action) {
    switch (action.type) {
        case reduxActions.LOGIN_START:
        case reduxActions.LOGIN_SUCCEEDED:
        case reduxActions.LOGIN_FAILED:
        return {
            status: action.progress,
            message: action.message
        }
        default:
        return state;
    }
}

export function registerStatus(state = defaultNetworkStatus, action) {
    switch (action.type) {
        case reduxActions.REGISTRATION_START:
        case reduxActions.REGISTRATION_SUCCEEDED:
        case reduxActions.REGISTRATION_FAILED:
        return {
            status: action.progress,
            err: action.err
        }
        default:
        return state;
    }
}

export function verifyStatus(state = defaultNetworkStatus, action) {
    switch (action.type) {
        case reduxActions.VERIFY_START:
        case reduxActions.VERIFY_SUCCEEDED:
        case reduxActions.VERIFY_FAILED:
        return {
            status: action.progress,
            message: action.message
        }
        default:
        return state;
    }
}

export function passwordRecoveryStatus(state = defaultNetworkStatus, action) {
    if (action.fetchType === fetchTypes.FORGOT_PASSWORD) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
            case reduxActions.RESOURCE_FETCH_SUCCESS:
            case reduxActions.RESOURCE_FETCH_FAIL:
                return {
                    status: action.progress,
                    message: action.message
                }
        }
    }

    return state;
}

export function passwordChangeStatus(state = defaultNetworkStatus, action) {
    if (action.fetchType === fetchTypes.CHANGE_PASSWORD) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
            case reduxActions.RESOURCE_FETCH_SUCCESS:
            case reduxActions.RESOURCE_FETCH_FAIL:
                return {
                    status: action.progress,
                    message: action.message
                }
        }
    }

    return state;
}

export function passwordResetStatus(state = defaultNetworkStatus, action) {
    if (action.fetchType === fetchTypes.RESET_PASSWORD) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
            case reduxActions.RESOURCE_FETCH_SUCCESS:
            case reduxActions.RESOURCE_FETCH_FAIL:
                return {
                    status: action.progress,
                    message: action.message,
                    error: action.error
                }
        }
    }

    return state;
}

const defaultUserSecurityStatus = {
    status: requestStatus.INACTIVE,
    message: '',
    error: '',
    data:{role:'', userName:'', newRole: ''}
};

export function userSecurity(state = defaultUserSecurityStatus, action){
    if (action.fetchType === fetchTypes.GET_SECURITY) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
            case reduxActions.RESOURCE_FETCH_FAIL:
                return {
                    status: action.progress,
                    message: action.message,
                    error: action.error,
                    data:{role:'', userName:''}
                };
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({},{
                    status: action.progress,
                    message: action.message,
                    error: action.error,
                    data: Object.assign({}, action.payload, {originalRole: action.payload.role, originalId: action.payload.id})
                });
            case accountConstants.userSecurityActions.CHANGE_ROLE:
                return Object.assign({},state,{
                    data: Object.assign({}, state.data, {role: action.role, id: action.id})
                });
            case accountConstants.userSecurityActions.CHANGE_ENTITY:
                return Object.assign({},state,{
                    data: Object.assign({}, state.data, {id: action.id, guid: action.guid, name: action.name})
                });
        }
    }
    return state;
}

const defaultUserState = {
    'access_token': null,
    'token_type': null,
    'expires_in': -1,
    'refresh_token': null,
    'as:client_id': null,
    'userName': '',
    'roles': accountRoles.NONE,
    'approvalStatus': accountStatuses.NONE,
    '.issued': null,
    '.expires': null,
    'loginState': loginStates.LOGGED_OUT
}

const savedUser = AuthDelegate.getSavedUser();

export function activeUser(state = savedUser || defaultUserState, action) {
    switch (action.type) {
        case reduxActions.SCHEDULE_TOKEN_REFRESH:
            return Object.assign({}, state, {
                tokenRefresher: action.refresher
            });
        case reduxActions.CANCEL_TOKEN_REFRESH:
            return Object.assign({}, state, {
                tokenRefresher: false
            });
        case reduxActions.SET_SESSION:
            return Object.assign({}, state, action.user, {
                loginState: loginStates.LOGGED_IN
            });
        case reduxActions.END_SESSION:
            if (state.tokenRefresher) {
                clearTimeout(state.tokenRefresher);
            }
            return defaultUserState;
        case reduxActions.UPDATE_USER_APPROVAL_STATUS:
            return Object.assign({}, state, {
                approvalStatus: action.status
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/account-reducer.js